export default "__VITE_ASSET__MqwZFF28__"